export const privacyContent = {
    content: `Last Updated: October 18, 2025

## 1. Introduction

Welcome to WizeHelper ("we," "us," or "our"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application.

Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the application.

## 2. Collection of Your Information

We may collect information about you in a variety of ways. The information we may collect via the Application includes:

### Personal Data

Personally identifiable information, such as your name and email address, that you voluntarily give to us when you register with the Application or when you choose to participate in various activities related to the Application, such as using our contact form.

### Derivative Data

Information our servers automatically collect when you access the Application, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Application.

### Data from Social Networks

We use Firebase Authentication, which may allow you to create an account using your existing social media accounts (like Google). If you do so, we will collect information from the social networking site, including your name, your social network username, location, gender, birth date, email address, profile picture, and public data for contacts.

### Reddit Data

When you use our services, we access Reddit data through the Reddit API. This includes public posts, comments, and usernames from the subreddits you specify. We do not collect your Reddit account credentials.

## 3. Use of Your Information

Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Application to:

*   Create and manage your account.
*   Provide you with the requested services, such as finding leads and analyzing posts.
*   Generate personalized direct messages and comments.
*   Email you regarding your account or order.
*   Respond to your comments and questions and provide customer service.
*   Monitor and analyze usage and trends to improve your experience with the Application.

### AI and Machine Learning

We utilize advanced artificial intelligence (AI) and machine learning technologies, to process the data you provide (such as Reddit post content) to generate insights, identify leads, and draft responses. This processing is automated and essential to the service's functionality. We do not use your personal data to train publicly available AI models without your explicit consent.

## 4. Disclosure of Your Information

We do not share, sell, rent, or trade your personal information with third parties for their commercial purposes.

We may share information we have collected about you in certain situations. Your information may be disclosed as follows:

### By Law or to Protect Rights

If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.

### Third-Party Service Providers

We may share your information with third parties that perform services for us or on our behalf, including data analysis, email delivery, hosting services, and customer service. We use **Google Firebase** for authentication and database services, and **Google Cloud AI** for natural language processing and content generation.

## 5. Data Storage and Security

We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.

We will retain the information for as long as your account is active or as needed to provide you services.

## 6. Your Rights

You have the right to:

*   **Access:** Request access to your personal data.
*   **Correction:** Request correction of the personal data that we hold about you.
*   **Erasure:** Request erasure of your personal data.

To exercise these rights, please contact us using the contact information provided below.

## 7. Changes to This Privacy Policy

We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.

## 8. Contact Us

If you have questions or comments about this Privacy Policy, please contact us through the contact form on our website.`
};
